// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rBye","content":"styles_content__2EMno"};